import React, { useState } from 'react';
import { SubmitBar } from '../components/submit-bar';
import {
  moveOnToNextPage,
  submitResponse,
  showConfetti,
  setStage
} from '../redux/actions/ui';
import {
  getCorrectElement,
  getDiscourseReviewMessage
} from '../components/side-bar';

import {
  Panel,
  setSideBarCorrect,
  setSideBarIncorrect,
  setSideBarOpenPanel,
  setSideBarSecondTry
} from '../sidebar-state';

import {
  DiscourseComp,
  ProblemStage,
  ITSEventType,
  DiscourseFixedData,
  SFFProblemType,
  DiscourseAnswers
} from 'its-pages';
import { DiscourseContent } from '../page-content/discourse-content';
import { useAppDispatch, useAppSelector } from '../redux/hooks';

interface ComponentProps {
  content: DiscourseContent;
}

//------------------------------------------------------------------------------
export const Discourse = (props: ComponentProps) => {
  const dispatch = useAppDispatch();
  const correctAnswerStreak = useAppSelector((state) => state.progression.correctAnswerStreak);
  const stage = useAppSelector((state) => state.ui.stage);

  const pageData = props.content.pageData as DiscourseFixedData;
  const isFixedDiscourse = pageData.type === SFFProblemType.DiscourseFixed;
  const fixedOptions = pageData.fixedOptions;
  const [firstTryScore, setFirstTryScore] = useState(0);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const showResult = stage === ProblemStage.ShowResult;
  const secondTry = stage === ProblemStage.SecondTry;

  const [answers, setAnnotAnswers] = useState<DiscourseAnswers>(
    pageData.answers || {}
  );

  const onAnswerSelected = (annotationId: string, selectedTagId: string) => {
    const updatedAnswers = { ...answers, [annotationId]: selectedTagId };
    setAnnotAnswers(updatedAnswers);

    const isFixedSelection =
      !isFixedDiscourse ||
      !!Object.values(fixedOptions).filter((v) => {
        v.selected;
      }).length;
    setDisableSubmit(
      Object.keys(updatedAnswers).length !== pageData.annotations.length &&
        isFixedSelection
    );
  };

  const onSubmit = () => {
    const score = pageData.score;

    const isCorrect = score >= 0.9;

    const gotoShowResults = () => {
      dispatch(submitResponse());
      if (isCorrect) {
        dispatch(showConfetti(true));
        setSideBarCorrect(getCorrectElement(pageData.seed));
      } else {
        setSideBarIncorrect(
          getDiscourseReviewMessage(correctAnswerStreak, score > firstTryScore)
        );
      }
      dispatch(setStage(ProblemStage.ShowResult));
    };

    const gotoSecondTry = () => {
      setFirstTryScore(score);
      dispatch(setStage(ProblemStage.SecondTry));
      setSideBarSecondTry(props.content.getSecondTryHint());
      setDisableSubmit(true);
      pageData.recordEvent(ITSEventType.firstTryWrong);
    };

    if (showResult) {
      dispatch(moveOnToNextPage());
    } else if (isCorrect) {
      gotoShowResults();
    } else if (stage === ProblemStage.CollectInput) {
      gotoSecondTry();
    } else {
      gotoShowResults();
    }
  };

  const onReviewed = () => {
    if (showResult) {
      setSideBarOpenPanel(Panel.None);
    }
  };

  return (
    <div className='Problem ProblemInput' style={{ padding: '0.5rem'}}>
      <DiscourseComp
        pageData={pageData}
        stage={stage}
        onReviewed={onReviewed}
        onAnswerSelected={onAnswerSelected}
      />
      <SubmitBar
        onSubmit={onSubmit}
        disableSubmit={disableSubmit}
        buttonText={
          secondTry ? 'Try Again' : showResult ? 'Continue' : 'Submit'
        }
        buttonClass={'SubmitBarButton'}
      />
    </div>
  );
};
